<mat-dialog-content>
    <div class="mat-dialog-text">{{'test-environment' | transloco}}</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <a mat-button href="https://www.rechterlijkebescherming.be">{{'to-live-environment' | transloco}}</a>
    <button mat-raised-button mat-dialog-close>{{'close' | transloco}}</button>
</mat-dialog-actions>
